/* ============================================================
   LAUZON — legal reading template behaviour.
   Loaded (deferred) from layout/theme.liquid alongside assets/lauzon-policy.css
   on policy pages and on the Dawn default page template.

   Progressive enhancement only. With this file absent the page keeps its head
   spacing, its left-aligned Bebas title and its body typography; it loses the
   kicker, the "Last updated" meta line and the contents rail. The two-column
   grid is gated in CSS on the .lz-has-toc class set here, so a JS-off page
   runs single-column rather than dropping the prose into the 4fr rail column.

   Shopify's policy renderer has no template to edit, which is why the kicker
   and the meta line are inserted here rather than in Liquid.
   ============================================================ */
(function () {
  'use strict';

  var DESKTOP = '(min-width: 901px)';

  var head = document.querySelector('.shopify-policy__title');
  var body = document.querySelector('.shopify-policy__body');
  var title = document.querySelector('.shopify-policy__title h1, #MainContent .page-width--narrow .main-page-title');
  if (!title) return;

  /* ---- Kicker ---- */
  if (!title.previousElementSibling || !title.previousElementSibling.classList.contains('kicker')) {
    var kicker = document.createElement('p');
    kicker.className = 'kicker';
    kicker.textContent = 'Policy';
    title.parentNode.insertBefore(kicker, title);
  }

  /* ---- "Last updated" meta line ----
     Policy pages only: the platform renderer opens Privacy with it as ordinary
     body prose. Moved under the h1 and stripped of its colon. */
  if (head && body) {
    var paras = body.querySelectorAll('.rte p');
    for (var i = 0; i < paras.length && i < 3; i++) {
      var text = (paras[i].textContent || '').trim();
      if (/^Last updated/i.test(text)) {
        var meta = document.createElement('p');
        meta.className = 'lz-policy-meta';
        meta.textContent = text.replace(/^(Last updated)\s*:\s*/i, '$1 ');
        head.appendChild(meta);
        paras[i].remove();
        break;
      }
    }
  }

  /* ---- Contents rail ----
     Built from the body's own h2s. Two or more, or it is not a rail. */
  if (!body) return;
  var rte = body.querySelector('.rte');
  if (!rte) return;

  var headings = Array.prototype.slice.call(rte.querySelectorAll('h2'));
  if (headings.length < 2) return;

  var used = Object.create(null);
  headings.forEach(function (h, index) {
    if (!h.id) {
      var slug = (h.textContent || '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 60) || 'section';
      if (used[slug]) slug = slug + '-' + (used[slug] += 1);
      else used[slug] = 1;
      h.id = 'policy-' + slug;
    }
    h.setAttribute('data-policy-index', String(index));
  });

  var nav = document.createElement('nav');
  nav.className = 'lz-policy-toc';
  nav.setAttribute('aria-label', 'Contents');

  var details = document.createElement('details');
  var summary = document.createElement('summary');
  summary.className = 'kicker';
  summary.textContent = 'Contents';
  details.appendChild(summary);

  var list = document.createElement('ul');
  var items = headings.map(function (h) {
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = (h.textContent || '').trim();
    li.appendChild(a);
    list.appendChild(li);
    return li;
  });
  details.appendChild(list);
  nav.appendChild(details);

  body.insertBefore(nav, body.firstChild);
  body.classList.add('lz-has-toc');

  /* Above 900 the rail is always open and the summary is a plain label; below,
     it is a closed disclosure. The toggle guard catches keyboard activation,
     which CSS pointer-events cannot. */
  var mq = window.matchMedia(DESKTOP);
  function syncOpen() {
    details.open = mq.matches;
  }
  syncOpen();
  if (mq.addEventListener) mq.addEventListener('change', syncOpen);
  else if (mq.addListener) mq.addListener(syncOpen);
  details.addEventListener('toggle', function () {
    if (mq.matches && !details.open) details.open = true;
  });

  /* ---- Current section ----
     The observer is only the trigger; the decision is a measurement, so a fast
     scroll or a jump to an anchor cannot leave two sections lit or none. */
  var current = -1;
  function mark() {
    var line = 140; // clears the compacted header (101px measured) plus air
    var index = 0;
    for (var i = 0; i < headings.length; i++) {
      if (headings[i].getBoundingClientRect().top <= line) index = i;
      else break;
    }
    if (index === current) return;
    if (items[current]) items[current].classList.remove('is-current');
    items[index].classList.add('is-current');
    current = index;
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(mark, {
      rootMargin: '-130px 0px 0px 0px',
      threshold: [0, 1]
    });
    headings.forEach(function (h) { io.observe(h); });
  }
  window.addEventListener('scroll', mark, { passive: true });
  mark();
})();
